import { render, staticRenderFns } from "./TableGrid.vue?vue&type=template&id=6a3ce2b8&scoped=true"
import script from "./TableGrid.vue?vue&type=script&lang=js"
export * from "./TableGrid.vue?vue&type=script&lang=js"
import style0 from "./TableGrid.vue?vue&type=style&index=0&id=6a3ce2b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3ce2b8",
  null
  
)

export default component.exports